const ABORT_ERROR_NAMES = new Set(['AbortError', 'CanceledError']);
const ABORT_ERROR_CODES = new Set(['ERR_CANCELED']);
const ABORT_ERROR_MESSAGES = new Set(['canceled']);

export type AbortLikeError = {
  name?: string;
  code?: string;
  message?: string;
  __CANCEL__?: boolean;
};

export const isAbortError = (e: AbortLikeError): boolean =>
  (!!e?.name && ABORT_ERROR_NAMES.has(e.name)) ||
  (!!e?.code && ABORT_ERROR_CODES.has(e.code)) ||
  (!!e?.message && ABORT_ERROR_MESSAGES.has(e.message)) ||
  e?.__CANCEL__ === true;

export const throwIfAborted = (signal: AbortSignal): void => {
  if (typeof signal.throwIfAborted === 'function') {
    signal.throwIfAborted();
    return;
  }
  if (signal.aborted) {
    throw new DOMException('Aborted', 'AbortError');
  }
};
